/*
  Subscription Gate
  Blocks page access behind an email or SMS signup form.

  This script lives outside Vite intentionally. It loads eagerly in the
  <head> (via theme.liquid) so the gate evaluates before body content
  renders — eliminating the flash of ungated content that module scripts
  cause. Enable it in Theme Settings > Subscription Gate.

  Gate elements are plain <div class="subscription-gate"> containers
  rendered by the email-access and sms-access sections, with data
  attributes for configuration.
*/
(function () {
  // --- Cookie helpers ---

  function getCookie(name) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      if (parts[0] === name) return parts[1];
    }
    return null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
  }

  // --- UTM parsing ---

  function parseUtmExceptions(str) {
    if (!str || !str.trim()) return [];
    return str.split(',').map(function (pair) {
      var parts = pair.trim().split('=');
      return { param: parts[0] && parts[0].trim(), value: parts.slice(1).join('=').trim() };
    }).filter(function (e) { return e.param && e.value; });
  }

  // --- Gate evaluation ---

  function evaluateGate(gate) {
    var cookieName = gate.getAttribute('data-cookie-name') || 'subscription_gate_accepted';
    var gateDefault = gate.getAttribute('data-gate-default') || 'show';
    var utmExceptions = gate.getAttribute('data-utm-exceptions') || '';
    var testMode = gate.hasAttribute('data-test-mode');

    if (!testMode && getCookie(cookieName)) return false;

    var exceptions = parseUtmExceptions(utmExceptions);
    var urlParams = new URLSearchParams(window.location.search);
    var hasMatch = exceptions.some(function (e) {
      var val = urlParams.get(e.param);
      return val && val.toLowerCase() === e.value.toLowerCase();
    });

    var shouldShow = gateDefault === 'show';
    if (hasMatch) {
      shouldShow = !shouldShow;
      if (!shouldShow && !testMode) setCookie(cookieName, 'true', 30);
    }

    return shouldShow;
  }

  // --- Content inert toggling ---

  function setContentInert(main, gate, value) {
    if (!main) return;
    for (var i = 0; i < main.children.length; i++) {
      if (!main.children[i].contains(gate)) {
        main.children[i].inert = value;
      }
    }
  }

  // --- Focus trap ---

  function handleKeydown(gate, e) {
    if (e.key !== 'Tab') return;
    var focusable = gate.querySelectorAll(
      'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // --- Activate / dismiss / close ---

  function activate(gate, main) {
    gate.classList.remove('hidden');
    gate.setAttribute('aria-modal', 'true');
    setContentInert(main, gate, true);

    gate._keydownHandler = function (e) { handleKeydown(gate, e); };
    gate.addEventListener('keydown', gate._keydownHandler);

    requestAnimationFrame(function () {
      var firstInput = gate.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    });
  }

  function dismiss(gate, main) {
    gate.classList.add('hidden');
    gate.style.display = 'none';
    gate.removeAttribute('aria-modal');
    setContentInert(main, gate, false);
  }

  function close(gate, main) {
    var testMode = gate.hasAttribute('data-test-mode');
    var cookieName = gate.getAttribute('data-cookie-name') || 'subscription_gate_accepted';

    if (!testMode) setCookie(cookieName, 'true', 30);

    gate.classList.add('opacity-0');
    setTimeout(function () {
      gate.style.display = 'none';
      gate.removeAttribute('aria-modal');
      setContentInert(main, gate, false);
      if (gate._keydownHandler) gate.removeEventListener('keydown', gate._keydownHandler);
    }, 500);
  }

  // --- Init ---

  document.addEventListener('DOMContentLoaded', function () {
    var gates = document.querySelectorAll('.subscription-gate');
    if (!gates.length) return;

    var main = document.getElementById('main');

    gates.forEach(function (gate) {
      var shouldShow = evaluateGate(gate);

      if (shouldShow) {
        activate(gate, main);
      } else {
        dismiss(gate, main);
      }

      // Klaviyo form submit handler
      var formId = gate.getAttribute('data-klaviyo-form-id');
      if (formId) {
        window.addEventListener('klaviyoForms', function (e) {
          if (e.detail.type === 'submit' && e.detail.formId === formId) {
            close(gate, main);
          }
        });
      }
    });
  });
})();
